import { NewNegociationAPI } from "@/api/financeiro/new-negociation.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";

const api = new NewNegociationAPI();

const listSefazReceita = (cpfCnpj: String): AxiosObservable<any> => {
  return api.listSefazReceita(cpfCnpj);
};

const listSefazProduto = (
  cpfCnpj: String,
  sefazReceitaId: number
): AxiosObservable<any> => {
  return api.listSefazProduto(cpfCnpj, sefazReceitaId);
};
const listReceitasAptasNegociacao = (body: {
  cpfCnpj: String;
  idSefazProduto: number;
  naoAptas: boolean;
  ascendingSort: boolean;
  page: number;
  size: number;
  sort: String;
}): AxiosObservable<any> => {
  return api.listReceitasAptasNegociacao(body);
};
const simularNegociacao = (body: {
  cpfCnpj: string;
  ids: [];
  parcelas: number;
  dataVencimento: string;
  dataNegociacao: string;
}): AxiosObservable<any> => {
  return api.simularNegociacao(body);
};
const saveNegociacao = (body: {
  cpfCnpj: string;
  ids: [];
  divided: number;
  date: string;
  dateNegotiation: string;
  observacao: string;
}): AxiosObservable<any> => {
  return api.saveNegociacao(body);
};
const aceitarTermosAndAutosNotificar = (body: {
  numeroAitp: [];
  cpfCnpj: string;
  numOrdem: number;
  lgpd: boolean;
  recapcha: string;
}): AxiosObservable<any> => {
  return api.aceitarTermosAndAutosNotificar(body);
};
const aceitarTermos = (body: {
  cpfCnpj: string;
  numOrdem: number;
  lgpd: boolean;
  recapcha: string;
}): AxiosObservable<any> => {
  return api.aceitarTermos(body);
};

const simularQuitacao = (
  cnpjCpf: string,
  idReceita: number
): AxiosObservable<any> => api.simularQuitacao(cnpjCpf, idReceita);

const salvarQuitacao = (
  cnpjCpf: string,
  idReceita: number
): AxiosObservable<any> => api.salvarQuitacao(cnpjCpf, idReceita);

const listParcelamentos = (
  cpfCnpj: string,
  paginacao: object
): AxiosObservable<any> => api.listParcelamentos(cpfCnpj, paginacao);

const listParcelas = (cpfCnpj: string, idGrupo: string): AxiosObservable<any> =>
  api.listParcelas(cpfCnpj, idGrupo);

const baixarDae = (
  cpfCnpj: string,
  ids: [],
  date: string
): AxiosObservable<any> => api.baixarDae(cpfCnpj, ids, date);

const historicoNegociacao = (
  cpfCnpj: string,
  idReceita: []
): AxiosObservable<any> => api.historicoNegociacao(cpfCnpj, idReceita);

const countSefazProdutos = (body: {
  cpfCnpj: String;
  idSefazProduto: number;
  naoAptas: boolean;
  ascendingSort: boolean;
  page: number;
  size: number;
  sort: String;
}): AxiosObservable<any> => api.countSefazProdutos(body);

const detailsReceitaQuitacao = (
  idReceitaGrupo: number,
  cpfCnpj: string
): AxiosObservable<any> => api.detailsReceitaQuitacao(idReceitaGrupo, cpfCnpj);

const aceitarTermosParcelamento = (
  cnpj: String,
  numOrdem: String,
  parcelamento: Boolean,
  recaptcha: String
): AxiosObservable<any> =>
  api.aceitarTermosParcelamento(cnpj, numOrdem, parcelamento, recaptcha);

const checkAceiteTermosParcelamento = (
  cnpj: String,
  numOrdem: String,
  parcelamento: Boolean
): AxiosObservable<any> =>
  api.checkAceiteTermosParcelamento(cnpj, numOrdem, parcelamento);

export default {
  listSefazReceita,
  listSefazProduto,
  listReceitasAptasNegociacao,
  simularNegociacao,
  saveNegociacao,
  aceitarTermosAndAutosNotificar,
  aceitarTermos,
  simularQuitacao,
  salvarQuitacao,
  listParcelamentos,
  listParcelas,
  baixarDae,
  historicoNegociacao,
  countSefazProdutos,
  detailsReceitaQuitacao,
  aceitarTermosParcelamento,
  checkAceiteTermosParcelamento,
};
